import { render, staticRenderFns } from "./customer_share_detail.vue?vue&type=template&id=8eb5b194&scoped=true&"
import script from "./customer_share_detail.vue?vue&type=script&lang=js&"
export * from "./customer_share_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_share_detail.vue?vue&type=style&index=0&id=8eb5b194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb5b194",
  null
  
)

export default component.exports